import { Divider, Stack, Typography } from "@mui/material";
import { IconLock } from "src/components/icons-mui/lock";
import { CBDetailsAccordion } from "../components/details-accordion";
import { CBFooter } from "../components/footer";
import { CBHeader } from "../components/header/header";
import { InfoBox } from "../components/info-box";
import { CBInvestedCapital } from "../components/invested-capital";
import { CBPricesNotTicking } from "../components/prices";
import { SpacedContainer } from "../components/spaced-container";
import { CBCertificateFee, CBExchangeRatio, CBEmission, CBLiquidationFigure, CBPerformanceFee, CBTradingVolume } from "../components/statistics";
import { useCertificateBoxContext } from "../context";

const BARRED_MESSAGE_TEST_ID = "barred-message";

export const CertificateBoxBarred = () => {
    const { dict, selectedCertificate: certificate } = useCertificateBoxContext();
    const isHiddenCertificate = certificate.isHidden;

    return (
        <>
            <CBHeader />
            <SpacedContainer>
                <CBPricesNotTicking />
                <Divider />
                <Stack spacing={1}>
                    <CBCertificateFee />
                    <CBPerformanceFee />
                    <CBInvestedCapital />
                </Stack>
                <Divider />

                <CBDetailsAccordion>
                    <Stack spacing={1}>
                        <CBEmission />
                        <CBLiquidationFigure />
                        <CBTradingVolume />
                        {isHiddenCertificate && <CBExchangeRatio />}
                    </Stack>
                    <Divider sx={{ pt: 2 }} />
                </CBDetailsAccordion>

                <InfoBox icon={<IconLock sx={{ mt: 0.2, width: "18px", height: "18px" }} />}>
                    <Typography data-test-Id={BARRED_MESSAGE_TEST_ID} fontSize="sm">
                        {dict.barredMessage}
                    </Typography>
                </InfoBox>

                <CBFooter />
            </SpacedContainer>
        </>
    );
};
